import { render } from "./FileStorage.vue?vue&type=template&id=603c0111"
import script from "./FileStorage.vue?vue&type=script&lang=js"
export * from "./FileStorage.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__